'use strict'

module.exports = function(value){
    return value.length?
                value.charAt(0).toLowerCase() + value.substring(1):
                value
}


//////////////////
// WEBPACK FOOTER
// ./~/to-style/src/stringUtils/toLowerFirst.js
// module id = 941
// module chunks = 0